endpointType